module.exports = __webpack_public_path__ + "img/check-white.d5c10cb8.svg";